import React from 'react';
import { NewCaseView } from 'pages/components';

const ContactCasesNewView = (props) => (
  <NewCaseView {...props} />
);

export default ContactCasesNewView;
